import './Bag.scss';

export default function Bag({ alt = 'Bag' }: {alt?: string}) {
  return <>
    <img className='BagIcon' src='/gms-haversack-logo-small.png' alt={alt} />
  </>;
}
